import { ButtonIcon, InteractiveIcon, Tooltip } from 'canoe';
import React, { useRef } from 'react';

import { useEventing } from 'commons/eventing';
import { useNodeCustomActions, useSelection } from 'craft/hooks';
import { useToolboxState } from 'craft/state';
import { ToolboxTabs } from 'craft/types';

export const InteractionsButton = React.memo(() => {
  const ref = useRef<HTMLButtonElement>(null);
  const { selection } = useSelection();
  const nodeId = selection.first;
  const customActions = useNodeCustomActions(nodeId) ?? [];

  const { track } = useEventing();
  const { setDockedState, setTab } = useToolboxState();

  const isLinked = !!customActions?.[0]?.handler;

  return (
    <Tooltip placement="top" offset="xxs" content="Interactions">
      <ButtonIcon
        ref={ref}
        size="small"
        active={isLinked}
        icon={InteractiveIcon}
        radius="small"
        color="white"
        onClick={() => {
          window.requestAnimationFrame(() => {
            if (setDockedState(false)) {
              track('editor.dockedToolbox.open');
            }
            setTab(ToolboxTabs.Interactions);
            const toolboxInteractions = document.getElementById('toolbox-interactions');
            if (!toolboxInteractions) {
              return;
            }
            toolboxInteractions.classList.add('bounce');
            setTimeout(() => {
              toolboxInteractions.classList.remove('bounce');
            }, 400);
          });
        }}
      />
    </Tooltip>
  );
});
